import { ChecklistDocument } from "../model/editorState";
import { LibraryEntry } from "../model/library";
import { newChecklistDocument } from "../state/checklist";

export function newLibraryEntry(checklistDocument?: ChecklistDocument): LibraryEntry {
  const now = new Date().getTime();
  return {
    present: checklistDocument || newChecklistDocument(),
    past: [],
    future: [],
    ctime: now,
    mtime: now,
  };
}
